import React, { useCallback, useState } from "react";
import { postAPI, getAPIBlob } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, API_ADMIN_ARBOL_CAUSAL } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import Dropzone from "../../../controls/DropZone";
import { Label, Spinner, SpinnerSize } from "@fluentui/react";

const ArbolCausal = () => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [load, setLoad] = useState(false);
  const [isError, setError] = useState(false);
  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
  }, [token]);

  const [file, setFile] = useState({ name: "Arbol Causal.xlsx" } as any);
  const get = () => {
    getAPIBlob(`${URL_SUPPORT}${API_ADMIN_ARBOL_CAUSAL}/${file.name}`, { Authorization: `Bearer ${token}` })
      .then((r) => {
        let file = r.result;
        let fileURL = URL.createObjectURL(file);
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.download = "Arbol Causal.xlsx";
        fileLink.click();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const upload = (file: any) => {
    let formData = new FormData();
    formData.append("file", file);
    setError(false);
    postAPI(`${URL_SUPPORT}${API_ADMIN_ARBOL_CAUSAL}`, formData, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        if (result.httpCode != 200) {
          setError(true);
        }
        setLoad(false);
      })
      .catch((error) => {
        console.log(error);
        setError(true);
        setLoad(false);
      });
  };

  const onDrop = useCallback((acceptedFiles: any) => {
    // this callback will be called after files get dropped, we will get the acceptedFiles. If you want, you can even access the rejected files too
    console.log(acceptedFiles);
    upload(acceptedFiles[0]);
    setFile(acceptedFiles[0]);
    setLoad(true);
  }, []);

  return (
    <section>
      <div className="row">
        <button
          data-testid="btnedit"
          hidden={true}
          onClick={() => {
            upload({});
            get();
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-4">
              <h1 className="titPrincipal colorTit mt-2">{"Árbol Causal"}</h1>
              <div className="row mb-1">
                <div className="col-12">
                  <p>Descarga el árbol causal aquí: </p>
                  <a
                    onClick={() => {
                      get();
                    }}
                    href="#">
                    {file !== undefined ? file.name : ""}
                  </a>
                </div>
                <div className="row mb-1">
                  <div className="col-12">
                    <Dropzone hidden={load} onDrop={onDrop} accept={"image/*"} />
                    <Spinner hidden={!load} size={SpinnerSize.large} title="Cargando árbol causal" />
                    <Label hidden={!isError}>Solo se aceptan archivos con extensión xlsx</Label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArbolCausal;
